import { getLocation } from './locale/utils'
import resolveResponse from 'contentful-resolve-response'
import { isSSR } from './isSSR'

export function isPreview() {
  if (isSSR) return false
  const params = new URLSearchParams(getLocation().search)
  return params.has('preview')
}

function getApiUrl() {
  const preview = isPreview()
  const host = preview ? 'preview.contentful.com' : 'cdn.contentful.com'
  const url = new URL(
    `https://${host}/spaces/bkt0ladonirv/environments/master/entries`
  )
  url.searchParams.set(
    'access_token',
    preview
      ? 's_1ttxiTtcHm1MoTKy27OXf8ChMByNTTZT9Tq_OAodQ'
      : '4-U4YnEddtaphjqc9Dtm42kMXzMGumOWPSpxlUuS3ow'
  )
  return url
}

export function getEntries(query) {
  query = {
    locale: 'en-US',
    ...query,
  }
  query.locale = 'en-US'

  const url = getApiUrl()

  for (let param in query) {
    if (Object.prototype.hasOwnProperty.call(query, param)) {
      url.searchParams.set(param, query[param])
    }
  }

  return fetch(url.toString())
    .then(res => res.json())
    .then(data => {
      if (data.sys.type === 'Error') {
        throw new Error(`Contentful error: ${data.message}`)
      }

      return {
        ...data,
        items: resolveResponse(data),
      }
    })
}
